// extracted by mini-css-extract-plugin
export default {"tabs":"Information_tabs__B9jDV","links":"Information_links__RensI","rules":"Information_rules__FAD5e"};